import React from "react";

import { saveAs } from "file-saver";
import FileAttachments from "../Attachments/FileAttachments";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import ZoomOutSharpIcon from "@material-ui/icons/ZoomOutSharp";
import DialogTitle from "@material-ui/core/DialogTitle";
import NavigateNextSharpIcon from "@material-ui/icons/NavigateNextSharp";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import ZoomInSharpIcon from "@material-ui/icons/ZoomInSharp";
import ScreenRotationAltOutlinedIcon from "@mui/icons-material/ScreenRotationAltOutlined";
import { Download, BackupTable } from "@material-ui/icons";
// import DownloadingIcon from "@mui/icons-material/Downloading";
// import BackupTableIcon from "@mui/icons-material/BackupTable";
import {
  Grid,
  TextField,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
  InputAdornment,
} from "@material-ui/core";
import { useState } from "react";
import downloadAttachments from "../../Functions/downloadAttachments";
import Tooltip from "@mui/material/Tooltip";

const AttachmentsCover = ({
  attachmentURLList,
  setAttachmentURLList,
  attachmentURL,
  setAttachmentURL,
  formState,
  attachments,
  invoice_attachmentRef,
}) => {
  const [rotateChevron, setRotateChevron] = useState(0);
  const [scale, setScale] = useState(0);
  const [open, setOpen] = React.useState(false);
  const imgRef = React.createRef();

  const [dimensions, setDimension] = React.useState({
    height: null,
    width: null,
  });

  // const [zoom, setZoom] = useState(null)

  const imgStyle = { height: dimensions.height, width: dimensions.width };
  // const initialHeight = imgRef.current?.clientHeight;
  // const initialWidth = imgRef.current?.clientWidth;
  const handleZoomIn = () => {
    // Fetching current height and width
    let height = imgRef.current.clientHeight;
    let width = imgRef.current.clientWidth;

    // Increase dimension(Zooming)
    setDimension({
      // height: height + 4,
      width: width + 70,
    });
  };

  const handleZoomout = () => {
    let height = imgRef.current.clientHeight;
    let width = imgRef.current.clientWidth;
    setDimension({
      // height: height + 4,
      width: width - 70,
    });
  };

  /////////import his
  const handleRotate = () => {
    let angle = 0;
    if (rotateChevron === 270) {
      angle = 0;
    } else {
      angle = rotateChevron + 90;
    }
    setRotateChevron(angle);
  };

  // const rotate = rotateChevron ? " : ""
  /////impport this
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const downloadImage = (src) => {
    saveAs(`${process.env.REACT_APP_API_URL}/${src}`); // Put your image url here.
  };
  return (
    <>
      {" "}
      {attachmentURLList?.length !== 0 && (
        <>
          <div>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              sx={{ mr: 2, ml: 1 }}
              disabled={
                attachmentURL?.path === attachmentURLList[0]?.path
                  ? true
                  : false
              }
              onClick={() => {
                var index = attachmentURLList.findIndex(
                  (obj) => obj?.id === attachmentURL?.id
                );
                setAttachmentURL(attachmentURLList[index - 1]);
              }}
            >
              <Tooltip title="Navigate Before">
                <NavigateBeforeIcon />
              </Tooltip>
            </Button>
            <Button
              variant="outlined"
              color="primary"
              sx={{ mr: 2 }}
              size="small"
              disabled={
                attachmentURL?.path ===
                attachmentURLList[attachmentURLList.length - 1]?.path
                  ? true
                  : false
              }
              onClick={() => {
                var index = attachmentURLList.findIndex(
                  (obj) => obj?.id === attachmentURL?.id
                );
                setAttachmentURL(attachmentURLList[index + 1]);
              }}
            >
              <Tooltip title="Navigate Next">
                <NavigateNextSharpIcon />
              </Tooltip>
            </Button>

            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={handleZoomIn}
              disabled={
                attachmentURL?.path?.substr(attachmentURL?.path?.length - 3) ===
                "pdf"
              }
              sx={{ mr: 2 }}
            >
              <Tooltip title="Zoom In">
                <ZoomInSharpIcon />
              </Tooltip>
            </Button>

            <Button
              variant="outlined"
              color="primary"
              size="small"
              sx={{ mr: 2 }}
              disabled={
                attachmentURL?.path?.substr(attachmentURL?.path?.length - 3) ===
                "pdf"
              }
              onClick={handleZoomout}
            >
              <Tooltip title="Zoom Out">
                <ZoomOutSharpIcon />
              </Tooltip>
            </Button>

            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={handleRotate}
              sx={{ mr: 2 }}
              disabled={
                attachmentURL?.path?.substr(attachmentURL?.path?.length - 3) ===
                "pdf"
              }
            >
              <Tooltip title="Rotate File">
                <ScreenRotationAltOutlinedIcon />
              </Tooltip>
            </Button>
            <a
              href={`${process.env.REACT_APP_API_URL}/${attachmentURL?.path}`}
              target="_blank"
            >
              <Button
                variant="outlined"
                color="primary"
                size="small"
                // onClick={() => downloadImage(attachmentURL)}
                sx={{ mr: 2 }}
              >
                <Tooltip title="Preview on Tab">
                  <BackupTable />
                </Tooltip>
              </Button>
            </a>

            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => downloadAttachments(attachmentURL?.path)}
              sx={{ mr: 2 }}
              disabled={
                attachmentURL?.path?.substr(attachmentURL?.path?.length - 3) ===
                "pdf"
              }
            >
              <Tooltip title="Download">
                <Download />
              </Tooltip>
            </Button>

            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth={"lg"}
            >
              <DialogTitle>
                <Typography variant="h6">Attachment View</Typography>
              </DialogTitle>
              <DialogContent
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FileAttachments
                  rotate={rotateChevron}
                  // imgsrc={attachmentURL}
                  //  imgPreview={imgPreview}
                  pdfHeight={"34%"}
                  docsrc={attachmentURL}
                  attachmentURLList={attachmentURLList}
                  // docPreview={docPreview}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => handleClose()}>
                  <ZoomOutSharpIcon />
                </Button>
              </DialogActions>
            </Dialog>
          </div>

          <FileAttachments
            // imgsrc={attachmentURL}
            //  imgPreview={imgPreview}
            rotate={rotateChevron}
            pdfHeight={"34%"}
            docsrc={attachmentURL?.path}
            attachmentURLList={attachmentURLList}
            formState={formState}
            // attachment={attachments}

            // docPreview={docPreview}
            imgRef={imgRef}
            dimensions={dimensions}
            zoom={scale}
          />
        </>
      )}
    </>
  );
};

export default AttachmentsCover;
